import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [totalSeconds, setTotalSeconds] = useState(13 * 60 + 11);
  useEffect(() => {
    if (totalSeconds <= 0) return;
    const interval = setInterval(() => {
      setTotalSeconds(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formatNum = (n: number) => n.toString().padStart(2, '0');
  return <span className="inline-flex items-center gap-1 font-heading font-bold text-white" data-id="element-112">
      <span className="bg-urgency-600 px-2 py-1 rounded text-lg md:text-xl tabular-nums animate-countdown" data-id="element-113">
        {formatNum(minutes)}
      </span>
      <span className="text-lg md:text-xl" data-id="element-114">:</span>
      <span className="bg-urgency-600 px-2 py-1 rounded text-lg md:text-xl tabular-nums animate-countdown" data-id="element-115">
        {formatNum(seconds)}
      </span>
    </span>;
}